import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { config } from '@Constants/rx-ui/constants';
import { trackFilterByValue, trackViewMore } from '@Containers/ResultsFilters/ResultsFiltersComponents/BarChartFilter/HOCs/analitycs';

const withBarChartFilterHandlers = (Component) => {
  function BarChartFilterHandlersHOC(props) {
    const {
      filter,
      updateFilterUserInputValue,
      isThesaurus,
      openTreeViewDialog,
      openCheckboxesDialog,
      fetchMoreFilterGroups,
      keyifyParamsForFiltersRequest,
      context,
      toggleFilterGroup,
      toggleFilterUserInput,
      openFilterByValueConfirmDialog,
    } = props;

    const onInputChange = useCallback(
      (value) => {
        updateFilterUserInputValue(filter, value);
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [filter]
    );
    const onClickViewMore = useCallback(() => {
      const filterId = filter.get('id');
      const title = filter.get('title').toLowerCase();
      const groupCount = filter.get('groupCount');

      if (isThesaurus) {
        openTreeViewDialog(filterId, keyifyParamsForFiltersRequest);
        trackViewMore(context, title, 'popup');
        return;
      }

      if (groupCount >= config.FILTER_MAX_GROUP_COUNT) {
        openCheckboxesDialog(filterId, keyifyParamsForFiltersRequest);
        trackViewMore(context, title, 'popup');
        return;
      }

      fetchMoreFilterGroups(filter);
      trackViewMore(context, title, 'expand');
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter, isThesaurus, keyifyParamsForFiltersRequest, context]);
    const onClickGroup = useCallback(
      (group) => {
        toggleFilterGroup(filter, group);
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [filter]
    );
    const onClickUserInput = useCallback(() => {
      const id = filter.get('id');
      const title = filter.get('title').toLowerCase();
      const userInputOpen = filter.get('userInputOpen');
      const userInputValue = filter.get('userInputValue');

      if (userInputOpen && userInputValue) {
        return openFilterByValueConfirmDialog(id);
      }

      toggleFilterUserInput(filter);
      if (!userInputOpen) {
        trackFilterByValue(context, title);
      }
      return undefined;
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter]);

    return (
      <Component
        {...props}
        onInputChange={onInputChange}
        onClickViewMore={onClickViewMore}
        onClickGroup={onClickGroup}
        onClickUserInput={onClickUserInput}
      />
    );
  }

  BarChartFilterHandlersHOC.propTypes = {
    filter: PropTypes.instanceOf(Map),
    updateFilterUserInputValue: PropTypes.func,
    isThesaurus: PropTypes.bool,
    openTreeViewDialog: PropTypes.func,
    openCheckboxesDialog: PropTypes.func,
    fetchMoreFilterGroups: PropTypes.func,
    keyifyParamsForFiltersRequest: PropTypes.string,
    context: PropTypes.string,
    toggleFilterGroup: PropTypes.func,
    toggleFilterUserInput: PropTypes.func,
    openFilterByValueConfirmDialog: PropTypes.func,
  };

  return BarChartFilterHandlersHOC;
};

export default withBarChartFilterHandlers;
